/**
 * L'état d'une partie de 421, entièrement sérialisable.
 *
 * Règle absolue : **aucune information de jeu ne vit en dehors de cet objet.**
 * C'est ce qui manquait à la v1, où le rampeau, le nombre de lancers du tour et
 * les résolutions partielles étaient des variables de module — perdues au moindre
 * rechargement, et impossibles à faire porter par un serveur autoritatif.
 *
 * Trois exigences apprises de la revue d'architecture :
 *   1. les dés ont une **identité stable** : une action de garde désigne des index
 *      de dés, jamais des valeurs (« garder les deux 2 » est ambigu) ;
 *   2. les **résolutions partielles** sont persistées : en décharge, un premier
 *      rampeau désigne le donneur et un second le receveur ; une coupure entre les
 *      deux ne doit rien perdre ;
 *   3. la **révision** est monotone : elle sert de base à l'anti-rejeu réseau.
 */
export const REGLES_MAISON = {
    id: "maison-2026-07",
    masse: 21,
    secDouble: true,
};
//# sourceMappingURL=etat.js.map